import {
  PaginatedFieldsProvider,
  ReadOnlyPaginatedFieldsTable,
  fieldCropTypeColumn,
  fieldNameColumn,
} from '@cibo/landmanager'
import { Loading, useOrgUser } from '@cibo/profile'
import { fieldProgramsColumn } from '@cibo/programs'
import { useParamAsInteger } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { generatePath } from '@cibo/core'
import { UserProgramsList } from 'components/UserProgramsList'
import { useMemo } from 'react'
import { FieldTableHeader } from '../../../components/FieldTable/FieldTableHeader'
import { Section } from '../../../consts/Theme'
import { GROWERS_ROUTES } from '../../../navigation/types/growersRoutes'

export const GrowersDetail = () => {
  const { t } = useTranslation('impact/pages/GrowersDetail')
  const userId = useParamAsInteger('userId')

  const user = useOrgUser(userId)

  const columns = useMemo(() => {
    // @todo come up with a better "current season" year
    const year = new Date().getFullYear()
    return [
      fieldNameColumn({ t }),
      fieldCropTypeColumn({ t, year }),
      fieldProgramsColumn({ t, variant: 'enrolled' }),
      fieldProgramsColumn({ t, variant: 'eligible' }),
    ]
  }, [t])

  if (!userId) return null

  return user.isLoading ? (
    <Stack flex={1} alignItems="center" justifyContent={'center'} spacing={3}>
      <Loading />
      <Typography color="text.secondary">{t('loading')}</Typography>
    </Stack>
  ) : user.data ? (
    <Stack justifyContent={'flex-start'} p={3}>
      <Stack spacing={3}>
        <Section sx={{ padding: 3 }}>
          <UserProgramsList userId={userId} />
        </Section>
        <Section sx={{ padding: 3 }}>
          <PaginatedFieldsProvider
            hideFilters={{
              userId: true,
              coverCrop: true,
              tillage: true,
              termsets: true,
              labels: true,
              lastUpdatedGt: true,
            }}
          >
            <Stack spacing={3}>
              <FieldTableHeader
                title={t('usersFields', { name: user.data.displayNameFull })}
                AddFieldsButtonProps={{
                  paths: {
                    draw: generatePath(GROWERS_ROUTES.DRAW_GROWER_FIELD, {
                      userId: userId.toString(),
                    }),
                    upload: generatePath(GROWERS_ROUTES.UPLOAD_GROWER_FIELD, {
                      userId: userId.toString(),
                    }),
                  },
                  buttonText: t('addField'),
                }}
              />
              <ReadOnlyPaginatedFieldsTable
                baseQuery={{ owner: userId }}
                columns={columns}
                hideCellFocus
              />
            </Stack>
          </PaginatedFieldsProvider>
        </Section>
      </Stack>
    </Stack>
  ) : (
    <Stack spacing={3}>{t('notFound')}</Stack>
  )
}
